import {REQUEST} from "../../../util/Request";
import * as types from "./types";

export const CargaDocumentalReducer = (state = {}, action) => {
  switch (action.type) {
    case types.ENVIAR_DOCUMENTOS:
      return {
        ...state,
        estadoEnviarDocumentos: REQUEST.PENDING
      };
    case types.DOCUMENTOS_ENVIADOS:
      return {
        ...state,
        estadoEnviarDocumentos: REQUEST.SUCCESS
      };
    case types.ERROR_DOCUMENTOS_ENVIADOS:
      return {
        ...state,
        estadoEnviarDocumentos: REQUEST.ERROR,
        errorEnviarDocumentos: action.error
      };
    case types.LIMPIAR_ENVIO_DOCUMENTOS:
      return {
        ...state,
        estadoEnviarDocumentos: undefined,
        errorEnviarDocumentos: undefined
      };
    default:
      return state;
  }
};
